module.exports = "/assets/58aa98e15bbd759cc9cacea4680cfb33.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NW.png
// module id = 1661
// module chunks = 0